import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { DealComponentDetailsImpl } from "../model/impl/DealComponentDetailsImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class DealComponentDetailsImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: DealComponentDetailsImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        DealComponentDetailsImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.baseCcyCd != null) {
      this.baseEncoder.writeStartFid(120, streamout);
      this.baseEncoder.writeObject(
        false,
        DealComponentDetailsImplEncoder.fidTypeMap.get(120),
        false,
        encodable.baseCcyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(120, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBaseCcyCd != null) {
      this.baseEncoder.writeStartFid(121, streamout);
      this.baseEncoder.writeObject(
        false,
        DealComponentDetailsImplEncoder.fidTypeMap.get(121),
        false,
        encodable.nonBaseCcyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(121, streamout);
    }
    /*Object encoding*/
    if (encodable.spotRt != null) {
      this.baseEncoder.writeStartFid(122, streamout);
      this.baseEncoder.writeObject(
        false,
        DealComponentDetailsImplEncoder.fidTypeMap.get(122),
        false,
        encodable.spotRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(122, streamout);
    }
    /*Object encoding*/
    if (encodable.outrightRt != null) {
      this.baseEncoder.writeStartFid(123, streamout);
      this.baseEncoder.writeObject(
        false,
        DealComponentDetailsImplEncoder.fidTypeMap.get(123),
        false,
        encodable.outrightRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(123, streamout);
    }
    /*Object encoding*/
    if (encodable.dealerMargin != null) {
      this.baseEncoder.writeStartFid(124, streamout);
      this.baseEncoder.writeObject(
        false,
        DealComponentDetailsImplEncoder.fidTypeMap.get(124),
        false,
        encodable.dealerMargin,
        streamout,
      );
      this.baseEncoder.writeEndFid(124, streamout);
    }
    /*Object encoding*/
    if (encodable.marketRt != null) {
      this.baseEncoder.writeStartFid(125, streamout);
      this.baseEncoder.writeObject(
        false,
        DealComponentDetailsImplEncoder.fidTypeMap.get(125),
        false,
        encodable.marketRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(125, streamout);
    }
    /*Object encoding*/
    if (encodable.localBookName != null) {
      this.baseEncoder.writeStartFid(126, streamout);
      this.baseEncoder.writeObject(
        false,
        DealComponentDetailsImplEncoder.fidTypeMap.get(126),
        false,
        encodable.localBookName,
        streamout,
      );
      this.baseEncoder.writeEndFid(126, streamout);
    }
    /*Object encoding*/
    if (encodable.remoteBookName != null) {
      this.baseEncoder.writeStartFid(127, streamout);
      this.baseEncoder.writeObject(
        false,
        DealComponentDetailsImplEncoder.fidTypeMap.get(127),
        false,
        encodable.remoteBookName,
        streamout,
      );
      this.baseEncoder.writeEndFid(127, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,DealComponentDetailsImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [120, "java.lang.String"],
    [121, "java.lang.String"],
    [122, "java.lang.Double"],
    [123, "java.lang.Double"],
    [124, "java.lang.Double"],
    [125, "java.lang.Double"],
    [126, "java.lang.String"],
    [127, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: DealComponentDetailsImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealComponentDetailsImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 120: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealComponentDetailsImplEncoder.fidTypeMap.get(120),
            streamin,
          );
          encodable.baseCcyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 121: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealComponentDetailsImplEncoder.fidTypeMap.get(121),
            streamin,
          );
          encodable.nonBaseCcyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 122: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealComponentDetailsImplEncoder.fidTypeMap.get(122),
            streamin,
          );
          encodable.spotRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 123: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealComponentDetailsImplEncoder.fidTypeMap.get(123),
            streamin,
          );
          encodable.outrightRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 124: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealComponentDetailsImplEncoder.fidTypeMap.get(124),
            streamin,
          );
          encodable.dealerMargin = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 125: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            DealComponentDetailsImplEncoder.fidTypeMap.get(125),
            streamin,
          );
          encodable.marketRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 126: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealComponentDetailsImplEncoder.fidTypeMap.get(126),
            streamin,
          );
          encodable.localBookName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 127: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            DealComponentDetailsImplEncoder.fidTypeMap.get(127),
            streamin,
          );
          encodable.remoteBookName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,DealComponentDetailsImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return DealComponentDetailsImplEncoder.fidTypeMap.has(fid);
  }
}
